export default __webpack_public_path__ + "static/gs-2-target--mobile-21c174d8e9205934f1a78b7f3f282168.jpg";